import TranslatableText from "@components/translations/TranslatableText";
import { useMemo } from "react";

interface FooterLink {
   href: string;
   label: string;
   ariaLabel?: string;
}

const FEEDBACK_EMAIL = "ex-act@fao.org";

const FOOTER_LINKS: FooterLink[] = [
   {
      href: "http://fao.org/contact-us/en/",
      label: "Contact us",
      ariaLabel: "Contact FAO"
   },
   {
      href: "http://fao.org/contact-us/terms/en/",
      label: "Terms and Conditions",
      ariaLabel: "View FAO Terms and Conditions"
   },
   {
      href: "http://fao.org/contact-us/data-protection-and-privacy/en/",
      label: "Data protection and privacy",
      ariaLabel: "View FAO Data Protection and Privacy Policy"
   },
   {
      href: "http://fao.org/contact-us/scam-alert/en/",
      label: "Scam Alert",
      ariaLabel: "View FAO Scam Alert information"
   },
   {
      href: "https://www.fao.org/aud/69204/en",
      label: "Report Misconduct",
      ariaLabel: "Report misconduct to FAO"
   }
];

const COPYRIGHT_LINK = {
   href: "https://www.fao.org/contact-us/terms/en/",
   ariaLabel: "View FAO copyright and terms"
};

const FooterLink = ({ href, label, ariaLabel, className }: FooterLink & { className?: string }) => (
   <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel || label}
      className={className}
   >
      {label}
   </a>
);

export const Footer = () => {
   const currentYear = useMemo(() => new Date().getFullYear(), []);

   const feedbackParamsComponents = [
      <strong key="email-bold" className="underline" />
   ];

   return (
      <footer className="app-footer app-footer-app d-flex align-items-center" role="contentinfo">
         <div className="container pt-0">
            <div className="app-row">
               <div className="app-footer-links col-12 col-md-6 col-lg-6">
                  <nav aria-label="Footer navigation">
                     <ul className="list-inline" role="list">
                        {FOOTER_LINKS.map((link) => (
                           <li key={link.href} className="list-inline-item" role="listitem">
                              <FooterLink {...link} className="fs-12" />
                           </li>
                        ))}
                     </ul>
                  </nav>
               </div>
               <div className="col-12 col-md-4 col-lg-4 d-flex align-items-center">
                  <TranslatableText 
                     className="fs-12 text-darker-gray" 
                     translationKey="user.feedback_request" 
                     translationParams={{ email: FEEDBACK_EMAIL }}
                     paramsComponents={feedbackParamsComponents}
                  />
               </div>
               <div className="col-12 col-md-2 col-lg-2 text-center text-md-end d-flex align-items-center justify-content-center justify-content-md-end">
                  <FooterLink 
                     {...COPYRIGHT_LINK}
                     label={`© FAO ${currentYear}`}
                     className="copyright fs-12"
                  />
               </div>
            </div>
         </div>
      </footer>
   );
};
